module.exports = __webpack_public_path__ + "img/viagem-punta-cana-carro.3de3fd37.jpeg";